// TODO: Port from Next.js app

interface FlowJourneyTimelineProps {
  events: any[];
  currentStage: string;
  flowName: string;
  maxVisibleEvents?: number;
}

export function FlowJourneyTimeline(props: FlowJourneyTimelineProps) {
  return <div>FlowJourneyTimeline placeholder</div>;
}
